// import Collapse from 'bootstrap/js/dist/collapse';
import { Collapse, Offcanvas, Modal } from "bootstrap";

window.bootstrap = {
    Collapse,
    Offcanvas,
    Modal
}